module.exports = __webpack_public_path__ + "img/pic_tab1_turnoncommenting.2ae3f499.png";